module.exports = __webpack_public_path__ + "static/media/iit_logo.2d646db9.png";